const REFRESH_ON_SHOW_EVENT = 'refreshOnShow';

class BatchCancelController {
  constructor(batchService, $scope) {
    this.name = 'cancelBatch';
    this.batchService = batchService;
    this.$scope = $scope;
    this.cancellable = false;
    this.cancelling = false;
    this.cancelled = false;
    this.unableToCancel = false;
    this.showCancelled = false;
    this.pollBatchStatus();
  }

  pollBatchStatus() {
    this.getBatchStatus.bind(this)();
    this.etlStatusInterval = setInterval(this.getBatchStatus.bind(this), 5000);
  }

  getBatchStatus() {
    this.batchService.getBatch(this.batchId).then(this.onBatchStatus.bind(this), this.onBatchStatusError.bind(this));
  }

  onBatchStatus(response) {
    const batch = response.data;
    if (batch) {
      this.cancelled = batch.isCancelled;
      this.cancellable = batch.isCancellable;
      if (this.unableToCancel) {
        clearInterval(this.etlStatusInterval);
      } else {
        this.cancelling = this.cancelling && !this.cancelled;
      }
    }
  }

  onBatchStatusError(error) {
    if (error && error.status === 404) {
      this.cancellable = false;
      this.cancelling = false;
      this.unableToCancel = false;
      clearInterval(this.etlStatusInterval);
    }
  }

  cancelBatch() {
    this.cancelling = true;
    this.batchService.cancelBatch(this.batchId).then(this.onBatchCancelled.bind(this), this.onBatchCancellingError.bind(this));
  }

  onBatchCancelled(data) {
    if (data && data.status === 202){
      this.cancelled = true;
      this.cancelling = false;
      this.unableToCancel = false;
      this.showCancelled = true;
    } else{
      this.cancelled = false;
      this.cancelling = false;
      this.unableToCancel = true;
    }
  }

  onBatchCancellingError() {
    clearInterval(this.etlStatusInterval);
    this.cancelling = false;
    this.cancellable = false;
    this.unableToCancel = true;
    setTimeout(() => this.$scope.$root.$broadcast(REFRESH_ON_SHOW_EVENT, {}), 2000);
  }
}

BatchCancelController.$inject = ['batchService', '$scope'];

export default BatchCancelController;




// WEBPACK FOOTER //
// ./app/components/batchCancel/batchCancel.controller.js